// extracted by mini-css-extract-plugin
module.exports = {"root":"CardItem_root__TKzxp","card":"CardItem_card__2SiWD","isSelected":"CardItem_isSelected__1IbaV","description":"CardItem_description__2oxSl"};